import { useMemo } from 'react';
import styles from './style.module.scss';
import { List, Divider, Row, Col, Spin } from 'antd';
import { Button, PageHeader } from 'components';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import useSingleInterviewStorePool from '../useSingleInterviewStorePool';
import { getInterviewStorePoolViewSections } from '../interviewStorePoolViewSections';

const ViewSection = ({ title, fields }) => (
  <List
    header={<div>{title}</div>}
    style={{ marginTop: 24 }}
    dataSource={fields}
    renderItem={(item) => (
      <List.Item>
        <b className={styles.itemName}>{item.text}</b>
        {item.value}
      </List.Item>
    )}
  />
);

const SingleInterviewStorePool = () => {
  const { t } = useTranslation();
  const { singleItem, loading, typesInterview } = useSingleInterviewStorePool();

  const sections = useMemo(
    () =>
      getInterviewStorePoolViewSections(t, singleItem, { typesInterview }),
    [t, singleItem, typesInterview],
  );

  const pageTitle = singleItem?.title || t('Vota Best Store');

  return (
    <div>
      <PageHeader title={pageTitle} />
      <div className={styles.content}>
        <Spin spinning={loading}>
          {sections.map((section) => (
            <ViewSection
              key={section.title}
              title={section.title}
              fields={section.fields}
            />
          ))}
        </Spin>
        <Divider />
        <Row gutter={16}>
          {singleItem?.can_update && (
            <Col>
              <Button>
                <Link
                  to={`/interviews/interview_store_pools/${singleItem?.id}/edit`}
                >
                  {t('MODIFICA')}
                </Link>
              </Button>
            </Col>
          )}
          {singleItem?.can_result && (
            <Col>
              <Button type={'secondary'}>
                <Link
                  to={`/interviews/interview_store_pools/${singleItem?.id}/results`}
                >
                  {t('Risultati')}
                </Link>
              </Button>
            </Col>
          )}
          <Col>
            <Button type={'secondary'}>
              <Link to={'/interviews/interview_store_pools'}>
                {t('TORNA INDIETRO')}
              </Link>
            </Button>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default SingleInterviewStorePool;
